/** Static files shipped with Neptune, served from the configured CDN (or local dev origin). */
export function neptuneAssetUrl(path: string): string {
    const baseUrl = String(import.meta.env.CDN_BASE_URL).replace(/\/+$/u, "");
    return `${baseUrl}/neptune_assets/${path.replace(/^\/+/u, "")}`;
}
